import { ModelBase } from 'store/model-base';
import { TaxFeeCategory, TaxType } from 'my-account/constants';

export class OrderTaxFee extends ModelBase {
    public static storeName: string = 'orderTaxFee';

    public name: string;
    public amount: number;
    public oneTime: number;
    public category: TaxFeeCategory;
    public type: string;

    public get isACP(): boolean {
        return this.type === TaxType.ACP;
    }
}
